export default __webpack_public_path__ + "static/media/MP4.9d05ac77.png";